import "./App.css";
import "./styles/index.css";

import { AppContext } from "/src/components/context/App";

import DirectorySearch from "/src/components/Search/Directory";
import MapSearch from "/src/components/Search/Map";

import { getDomain, getConfig } from "/src/config/master.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

function App({ post_type, search_type, search_params, search_taxonomy, page_params, form, pager, fullscreen, spinner }) {

  /* Boolean values */
  form = !(typeof form === "undefined");
  pager = !(typeof pager === "undefined");
  fullscreen = !(typeof fullscreen === "undefined");

  const domain = getDomain();
  const config = getConfig({ post_type, search_type, fullscreen, spinner });

  let searchParams = {};
  try {
    searchParams = JSON.parse(search_params);
  }
  catch (e) {
    searchParams = {};
  }

  let searchTaxonomy = {};
  try {
    searchTaxonomy = JSON.parse(search_taxonomy);
  }
  catch (e) {
    searchTaxonomy = {};
  }

  switch (search_type) {
    case "directory":
      return (
        <AppContext value={config}>
          <div className={`${domain} ${post_type} ${search_type}`}>
            <DirectorySearch defaultSearchParams={searchParams} defaultSearchTaxonomy={searchTaxonomy} showForm={form} showPager={pager} />
          </div>
        </AppContext>
      );
    case "map":
      return (
        <AppContext value={config}>
          <div className={`${domain} ${post_type} ${search_type}`}>
            <MapSearch defaultSearchParams={searchParams} defaultSearchTaxonomy={searchTaxonomy} showForm={form} />
          </div>
        </AppContext>
      );
    default:
      return (
        <div className={domain}>
          <div>Unknown Search Type</div>
        </div>
      );
  }

}

export { App };
